import React from 'react';
import { HStack, Box, SkeletonCircle, SkeletonText, List } from '@chakra-ui/react';

export default function OfferSkeleton (){
    return (
    <HStack 
        position="relative"
        boxShadow="2px 2px 20px 0px #00000026"
        borderRadius="4px"
        h="125px" w="385px" maxW="100%" 
        p=".5rem 1rem" m="14px">

        <SkeletonCircle w="90px" h="90px" my="auto" />

        <List fontSize="12px" w="calc(100% - 100px)">
            <SkeletonText noOfLines={4} w="140px"/>
        </List>

        <Box pos="absolute" right="16px" top="8px">
            <SkeletonCircle size="6" />
        </Box>
    </HStack>
)};